import React from 'react';
import { reviews } from '../../data/storeData';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export default function ReviewGrid() {
  return (
    <section className="py-24 bg-cream border-y border-brass/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-4">Word from the Workshop</h2>
          <div className="flex justify-center gap-1 text-brass mb-4">
            {[...Array(5)].map((_, i) => (
              <SafeIcon key={i} icon={FiIcons.FiStar} className="fill-current w-5 h-5" />
            ))}
          </div>
          <p className="font-sans text-sm uppercase tracking-widest text-saddle">Based on 500+ Reviews</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <div key={review.id} className="bg-white p-8 shadow-sm border border-creamDark relative group">
              <div className="absolute top-0 left-0 w-full h-1 bg-brass scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-500"></div>
              <div className="flex gap-1 text-brass mb-6">
                {[...Array(review.rating)].map((_, i) => (
                   <SafeIcon key={i} icon={FiIcons.FiStar} className="fill-current w-4 h-4" />
                ))}
              </div>
              <p className="font-serif text-navy text-lg italic mb-6 leading-relaxed">"{review.text}"</p>
              <p className="font-sans text-sm font-semibold text-saddle uppercase tracking-wide">— {review.author}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}